<template>
  <div class="picker" :style="styleOption">
    <div class="picker_firstcolor">
      <ul>
        <li v-for="color in firstColorList"
        :key="color.index"
        :style="color"
        :class="color.class ? color.class : ''"
        @click="selectHandler(color['background-color'])"/>
      </ul>
    </div>
    <div class="picker_color">
      <ul v-for="colors in colorList" :key="colors.index">
        <li v-for="color in colors" :key="color.index" :class="color.class ? color.class : ''" :style="color.class ? '' : color" @click="selectHandler(color['background-color'])"/>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    option: {
      type: Object
    }
  },
  data: function () {
    return {
      firstColorList: null,
      colorList: null
    }
  },
  created () {
    this.drawColor()
  },
  name: 'ucolor',
  computed: {
    styleOption: function () {
      this.$root.$el.addEventListener('mouseup', this.mouseUp)
      if (this.option) {
        return {
          left: this.option.x + 'px',
          top: this.option.y + 'px'
        }
      } else {
        return {
          left: '0px',
          top: '0px'
        }
      }
    },
    getType: function () {
      console.log(this.option)
      return (this.option && this.option.type) ? this.option.type : ''
    }
  },
  methods: {
    selectHandler: function (e) {
      var st = sessionStorage.getItem('color')
      var ar = JSON.parse(st)
      if (toString.call(ar) !== '[object Array]') {
        ar = []
        sessionStorage.removeItem('color')
      }
      e = e === undefined ? null : e
      console.log('indexof ', ar, e, ar.indexOf(e))
      if (ar.indexOf(e) === -1) {
        ar.unshift(e)
        if (ar.length > 14) {
          ar.pop()
        }
      } else {
        ar = ar.splice(ar.indexOf(e), 1).concat(ar)
      }
      sessionStorage.setItem('color', JSON.stringify(ar))
      this.$emit('select', this.newEvent(this.getType, this, true, e))
      this.$emit('update:option', null)
    },
    mouseUp: function (e) {
      if (!this.isTarget(e, this.$el)) {
        this.$emit('update:option', null)
      }
      this.$root.$el.removeEventListener('mouseup', this.mouseUp)
    },
    getColor: function (r, g, b) {
      return '' + (Math.floor(r) === 0 ? '00' : Math.floor(r).toString(16)) +
      (Math.floor(g) === 0 ? '00' : Math.floor(g).toString(16)) +
      (Math.floor(b) === 0 ? '00' : Math.floor(b).toString(16))
    },
    getLineColor: function (i, b, m, s) {
      switch (i) {
        case 0 :
          return {'background-color': '#' + this.getColor(b, b, b)}
        case 1 :
          return {'background-color': '#' + this.getColor(s, s, s)}
        case 2 :
          return {'background-color': '#' + this.getColor(b, s, s)}
        case 3 :
          return {'background-color': '#' + this.getColor(b, m, s)}
        case 4 :
          return {'background-color': '#' + this.getColor(b, b, s)}
        case 5 :
          return {'background-color': '#' + this.getColor(m, b, s)}
        case 6 :
          return {'background-color': '#' + this.getColor(s, b, s)}
        case 7 :
          return {'background-color': '#' + this.getColor(s, b, m)}
        case 8 :
          return {'background-color': '#' + this.getColor(s, b, b)}
        case 9 :
          return {'background-color': '#' + this.getColor(s, m, b)}
        case 10 :
          return {'background-color': '#' + this.getColor(s, s, b)}
        case 11 :
          return {'background-color': '#' + this.getColor(m, s, b)}
        case 12 :
          return {'background-color': '#' + this.getColor(b, s, b)}
        case 13 :
          return {'background-color': '#' + this.getColor(b, s, m)}
        default :
          return {'background-color': '#' + this.getColor(b, s, s)}
      }
    },
    drawColor: function (hd) {
      var ar = JSON.parse(sessionStorage.getItem('color'))
      if (!ar) {
        ar = []
      }
      console.log('indexof ', ar)
      var i, j, base, mid, side, step, mstep
      for (i = 0; i < ar.length; i++) {
        if (ar[i] === null) {
          ar[i] = {'class': 'not'}
        } else {
          ar[i] = {'background-color': ar[i]}
        }
      }
      this.firstColorList = ar
      var li = []
      step = 0xFF / 4
      mstep = 0xFF / 9
      for (i = 0; i < 2; i++) {
        li[i] = []
        for (j = 0; j < 6; j++) {
          if (i === 0 && j === 0) {
            li[i][j] = {'class': 'not'}
          } else {
            base = 0xFF - mstep * (j - 1)
            side = mstep * (5 - j)
            mid = base - mstep * (j + 1)
            li[i][j] = this.getLineColor(i, base, mid, side)
          }
        }
      }
      for (i = 2; i < 14; i++) {
        li[i] = []
        base = 0xFF
        for (j = 0; j < 4; j++) {
          side = step * (3 - j)
          mid = base - mstep * (j + 1)
          li[i][j] = this.getLineColor(i, base - mstep / 3, mid, side)
        }
        for (j; j < 6; j++) {
          base = 0xFF - step * (j - 3) - mstep / 3
          mid = 0xFF - mstep * (j + 1)
          li[i][j] = this.getLineColor(i, base, mid, side)
        }
      }
      this.colorList = li
    }
  }
}
</script>

<style scoped>
.picker {
  position: absolute;
  padding: 5px 5px 5px 5px;
  line-height: 10px;
  z-index: 15;
  background-color: var(--bg-white);
  border: solid 1px var(--line-base);
}
.picker_color {
  display: flex;
  flex-direction: row;
}
.picker_color ul {
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
}
.picker li {
  padding: 0px 0px 0px 0px;
  margin: 1px 1px 0px 0px;
  height: 15px !important;
  width: 15px !important;
  overflow: hidden !important;
  display: inline-table;
}
.picker_firstcolor ul {
  margin: 0px 0px 10px 0px;
  padding: 0;
  display: flex;
  flex-direction: row;
}
.not {
  background-image: url('~@/assets/toolbar/p-01.png');
  background-repeat: round;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/Ucolor.vue